const ATTACHMENT_UPLOAD_TYPES = new Set(['PDF', 'DICOM']);

export function normalizeUploadType(type) {
  return String(type ?? '').trim().toUpperCase();
}

export function isAttachmentUploadType(type) {
  return ATTACHMENT_UPLOAD_TYPES.has(normalizeUploadType(type));
}

export function uploadBatchStatusForType(type) {
  return isAttachmentUploadType(type) ? 'Completed' : 'Pending';
}

export function sftpUploadStatusForType(type) {
  return isAttachmentUploadType(type) ? 'processed' : 'pending';
}

export function allowedExtensionsForType(type) {
  const t = normalizeUploadType(type);
  if (t === 'PDF') return ['.pdf'];
  if (t === 'DICOM') return ['.dcm', '.dicom', '.zip'];
  return ['.zip'];
}

export function isAllowedExtensionForType(fileName, type) {
  const lower = String(fileName || '').toLowerCase();
  return allowedExtensionsForType(type).some((ext) => lower.endsWith(ext));
}

export const DROP_ACCEPT = '.zip,.pdf,.dcm,.dicom';
export const DROP_EXTENSIONS = ['.zip', '.pdf', '.dcm', '.dicom'];
